import React, {createContext, useEffect, useState} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,

  Navigate,
  useLocation
} from "react-router-dom";
//import Userfront, { PasswordResetForm } from "@userfront/toolkit/react";
import { useTelegramWebApp } from '@telegram-web-app/react';
//import { TelegramProvider, useTelegram } from "services/teleprovider";

import Nav from "./components/nav";
import Home from "./components/home";
import Dashboard from "./components/dashboard";

import Team from "./components/team";
import Farm from "./components/farm";
import Esket from "./components/esket";
import Canv from "./components/canv";
import Esketchos from "./components/esketchos";
import Story from "./components/thumbs/story";
import Sujet from "./components/thumbs/sujet";
import Sket from "./components/sket";
import SujetP from "./components/thumbs/sujetP";

//Userfront.init("6nz5z4rb");

export const UserContext = createContext(null);
export const tenant="6nz5z4rb";
export default function App() {

  const telegram = useTelegramWebApp();

  async function makeUser(user) {
    await fetch("https://buben-sha.herokuapp.com/api/ufront/records/member", {
      method: "POST",
      body:JSON.stringify(user),
      headers: {
        'x-apikey': 'today',

      }
    }).then(a=>{


    });
  }


  async function fetchUserData(pro) {
    const response = await fetch("https://buben-sha.herokuapp.com/api/records/member?filter=tgId,eq," + pro.id);
    await  response.json().then(
      a=>{
if(a.records.length>=1) {
          const r=a.records[0];
          setUserw(a.records[0]);
          const uu=pro;
          uu.rights=r.rghts;
          uu.fid=r.id;
          setUser(uu);
        }else{
         setUserw('senf');
          makeUser({name:pro.username,userfront:'tele',tgId:pro.id});

        }
        //  fetchUserFr();

      //  setUser(a.records[0]);
         }
    )

  }


  const [user, setUser] = useState(null);
  const [chat, setChat] = useState(0);
  const [ans, setAns] = useState(null);
  const [userw, setUserw] = useState(null);
  useEffect(() => {
telegram.WebApp.ready();
    telegram.WebApp.expand();
const store = telegram.WebApp.initDataUnsafe.user ? telegram.WebApp.CloudStorage : null;
   // telegram.WebApp.requestWriteAccess();
    //setChat(1);
  if(!user && telegram.WebApp.initDataUnsafe.user) {
console.log( telegram.WebApp.initDataUnsafe.user);
    setChat(telegram.WebApp.initDataUnsafe.chat ? telegram.WebApp.initDataUnsafe.chat.id : telegram.WebApp.chat_instance);
fetchUserData(telegram.WebApp.initDataUnsafe.user);
const u=telegram.WebApp.initDataUnsafe.user;
u.rights=false;
u.fid=false;
    setUser(u);
  }

  /*
if(telegram.WebApp.CloudStorage){
  setAns('a');
store.getItem('key', (s,a)=>setAns(a));
}else{  setAns('b');}

*/

    //   console.log(telegram.WebApp.initDataUnsafe.user);

 //
   });


  return (
    <Router>
<UserContext.Provider value={
  user
  }>
  {chat==0 ? (
      <div className="lg:container lg:mx-auto md:container md:mx-auto" style={{position:'relative'}} id="ttid">

<Routes>


          <Route path="/" element={telegram.WebApp.initDataUnsafe.user ?  <Esket/> : <Esketchos/>}/>
  <Route path="draw" element={ <Esket/>}/>
  <Route path="story/:id" element={ <Story/>}/>
  <Route path="sujet/:idS" element={ <SujetP/>}/>
  <Route path="sujetP/:idS" element={ <Canv/>}/>
  <Route path="sujet_/:idS" element={ <Canv/>}/>
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard/>
              </RequireAuth>
            }
          />
        </Routes>
      </div>
  ) : (

    <div>{chat}</div>

    )}
</UserContext.Provider>
    </Router>
  );
}






function RequireAuth({ children }) {
  let location = useLocation();


  return children;
}
